
const cities = [
  {
    name: "Гуанчжоу",
    url: "/cities/guangzhou.jpg",
    description:
      "Огромный портовый город к северо-западу от Гонконга на реке Жемчужной. Славится своим историческим наследием, которое насчитывает более 2000 лет. Его порт является главным транспортным и торговым узлом Китая. Его население составляет около 14 миллионов человек. Город известен своей авангардной архитектурой, включая знаковую башню Кантон и Оперный театр Гуанчжоу, спроектированный бюро Заха Хадид.Считается излюбленным местом для шопинга: тут можно найти все, от роскошных брендов в комплексе TaiKoo Hui и CTF Finance Centre до лавок местных сувениров и изделий кустарных промыслов на пешеходной улице Шанкшаджу.",
    attractions: [
      "Башня Кантон",
      "Храм Чэнь",
      "Парк Юэсю",
      "Остров Шамянь",
      "Оперный театр Гуанчжоу",
    ],
  },
  {
    name: "Гуйлинь ",
    url: "/cities/guilin.jpg",
    description:
      "Гуйлин, расположенный в Гуанси-Чжуанском автономном районе Китая, очаровывает своей исключительной природной красотой. Этот город окружен завораживающим пейзажем изумрудно-зеленых холмов, извилистых рек и обширных рисовых террас, меняющих оттенки в зависимости от сезона. Суть Гуйлина заключается в его спокойной сельской местности, где время кажется замедляющимся, а гармоничное сочетание природы и сельской жизни создает умиротворенное убежище от суеты мира. Туристов привлекают не только живописные виды, но и возможность погрузиться в богатый культурный узор, созданный местными этническими народностями, включая чжуан, яо и мяо, каждая из которых добавляет свои уникальные традиции и образ жизни в привлекательность региона.",
    attractions: [
      "Река Ли ",
      "Пещера Тростниковой Флейты",
      "Холм Слоновый хобот ",
      "Парк «Семи звезд» ",
      "Уезд Яншо",
    ],
  },
  {
    name: "Куньмин",
    url: "/cities/kunmin.jpg",
    description:
      'Столица провинции Юньнань, часто называется "Городом Весны" из-за своего мягкого климата круглый год. Он служит воротами в многообразие культур и захватывающих пейзажей Юньнаня, включая Лес из Камня, объект Всемирного наследия ЮНЕСКО, известный своими естественными известняковыми формациями. Многонациональная атмосфера добавляет яркие краски в традиции и праздники города. Сочетание природной красоты, культурного разнообразия и исторической значимости делает Куньмин завораживающим местом для путешествия. ',
    attractions: [
      "Каменный лес Шилинь",
      "Озеро Дяньчи",
      "Парк Зелёного озера",
      "Буддистский храм Юаньтун",
      "Западные Холмы",
    ],
  },
  {
    name: "Нанкин",
    url: "/cities/nanjing.jpg",
    description:
      'Нанкин, столица провинции Цзянсу в Китае, славится своим глубоким историческим наследием. Известный как "Южная Столица", он служил центром власти для нескольких китайских династий. Богатое прошлое Нанкина отражено в его хорошо сохранившихся исторических местах, включая Стену Минской Династии, которая является одной из самых больших городских стен, когда-либо построенных, и Мавзолей Сунь Ятсена, посвященный основателю Республики Китай. Живые улицы города свидетельствуют о его динамичной культуре, предлагая эклектичное сочетание традиционной кухни, оживленных рынков и современных арт-сцен.  ',
    attractions: [
      "Мавзолей Сунь Ятсена",
      "Стена Династии Мин",
      "Храм Конфуция (Фуцзи Мяо)",
      "Озеро Сюаньву",
      "Пурпурная гора (Зиджин Шань)",
    ],
  },
  {
    name: "Пекин",
    url: "/cities/beijing.jpg",
    description: "Пекин, столица Китая, - это город, где переплетаются древняя история и современность. Он славится такими знаковыми достопримечательностями, каждая из которых рассказывает о богатом прошлом Китая. Древние хутуны (узкие улочки) города и традиционные чайные домики предлагают взгляд на старый Пекин, в то время как высотные небоскребы и оживленные торговые районы демонстрируют его модернизацию. Пекин также является культурным центром, где проводятся многочисленные фестивали, художественные выставки и кулинарные изыски, отражающие разнообразное наследие китайского народа. Несмотря на быстрое городское развитие, Пекин сохраняет свою историческую привлекательность и продолжает быть ярким свидетельством эволюции Китая. ",
    attractions: [
      "Великая Китайская Стена",
      "Запретный Город",
      "Тяньаньмэнь площадь",
      "Храм Неба",
      "Летний дворец Ихэюань"
      ],
  },
  {
    name: "Сиань",
    url: "/cities/xian.jpg",
    description: "Сиань, столица провинции Шэньси в Китае, - город, пропитанный историей, служащий восточным концом Великого Шелкового пути и древней столицей для нескольких самых важных династий в истории Китая, включая Цинь, Хань и Тан. Знаменитый своей Терракотовой армией, охраняющей гробницу императора Цинь Шихуанди, он является воротами в богатое культурное наследие Китая. Город сочетает в себе древние достопримечательности, такие как древние городские стены и Большая Пагода Дикого Гуся, с современной городской застройкой. Сиань также известен своей кухни провинции Шэньси, сочетающую в себе мусульманские традиции и китайские вкусы.  ",
    attractions: [
      "Терракотовая армия",
      "Древние городские стены Сианя",
      "Большая пагода Диких гусей",
      "Исторический музей провинции Шэньси",
      "Сианьская соборная мечеть",
      ],
  },
  {
    name: "Сучжоу",
    url: "/cities/suzhou.jpg",
    description: 'Сучжоу, расположенный в провинции Цзянсу на востоке Китая, известен своими изысканными классическими садами, традиционной архитектурой у воды и как колыбель культуры У. Этот город, часто называемый "Венецией Китая", переплетен каналами, каменными мостами и тщательно спланированными садами, такими как Сад Скромного Чиновника и Затяжной Сад, которые являются объектами Всемирного наследия ЮНЕСКО. Город также является центром производства шелка, гордясь долгой историей мастерства в области шелководства, демонстрируемой в Музее шелка Сучжоу.  ',
    attractions: [
      "Музей шелка Сучжоу",
      "Сад Мастера Сетей",
      "Ворота Пань",
      "Сад Львиная Роща",
      "Сад Скромного Чиновника",
      ],
  },
  {
    name: "Ухань",
    url: "/cities/wuhan.jpg",
    description: 'Ухань, столица провинции Хубэй в центральном Китае, является крупным мегаполисом, раскинувшимся вдоль реки Янцзы. Известный как "Чикаго Китая", Ухань является значительным промышленным и коммерческим центром с сильным акцентом на производство, технологии и образование, включая множество университетов и научно-исследовательских институтов. Город известен своей ролью в современной истории Китая, особенно Восстанием в Учане 1911 года, которое привело к падению династии Цин. Культурные достопримечательности Уханя включают Башня Жёлтого журавля, символ древнего наследия города, и Музей провинции Хубэй, демонстрирующий богатые исторические и культурные артефакты региона. ',
    attractions: [
      "Башня Жёлтого журавля",
      "Музей провинции Хубэй",
      "Уханьский университет",
      "Восточное озеро",
      "Аллея Хубу",
      ],
  },
  {
    name: "Ханчжоу",
    url: "/cities/hangzhou.jpg",
    description: "Столица провинции Чжэцзян в Китае, славится своей живописной красотой и богатой историей. Этот город известен Западным озером, объектом Всемирного наследия ЮНЕСКО, где древние пагоды, культурные храмы и пышные сады создают спокойный и живописный пейзаж. Ханчжоу также является центром чайной культуры, особенно известным своим чаем Лунцзин, одним из лучших сортов зеленого чая в Китае. Современность города проявляется в процветающей технологической индустрии, главный офис Alibaba, гиганта мировой электронной коммерции, расположен здесь. ",
    attractions: [
      "Западное озеро Сиху",
      "Буддийский Храм Линьинь",
      "Чайная плантация Лунцзин Драконий колодец",
      "Великий китайский канал",
      "Остров Гушань Гора одиночества",
      ],
  },
  {
    name: "Харбин",
    url: "/cities/harbin.jpg",
    description: 'Столица провинции Хэйлунцзян на северо-востоке Китая, знаменит своим потрясающим Фестивалем льда и снега, одним из крупнейших в мире подобных мероприятий, привлекающим посетителей со всего мира своими огромными, сложно вырезанными ледяными скульптурами. Известный как "Город льда", Харбин обладает уникальным сочетанием китайских и русских влияний, что видно в его архитектуре, культуре и кухне, наследии его исторической роли в качестве ключевого узла на Транссибирской магистрали. Жестокие холода зимой создают идеальный фон для его ледяных аттракционов, в то время как летом город преображается в приятное место отдыха с парками и реками, предлагающими убежище от жары. ',
    attractions: [
      "Фестиваль льда и снега",
      "Собор Святой Софии",
      "Главная пешеходная улица называется Чжунъян",
      "Солнечный Остров",
      "Харбинский полярный океанариум",
      ],
  },
  {
    name: "Циндао",
    url: "/cities/qingdao.jpg",
    description: "Прибрежный город в провинции Шаньдун, славится своим живописным морским пейзажем, немецкой колониальной архитектурой и яркой культурной историей. Он известен проведением ежегодного Международного пивного фестиваля Циндао, отмечающего его пивоваренное наследие, особенно пивоварню Цинтао, основанную немецкими поселенцами. Смешение восточных и западных влияний города заметно в его исторических районах, где краснокрышие виллы и брусчатые улицы сочетаются с традиционными китайскими двориками.  ",
    attractions: [
      "Пивоварня Циндао",
      "Парк Чжуншань",
      "Пирс Чжаньцяо",
      "Пляж № 1 залив Хойцюань",
      "Национальный парк Лаошань",
      ],
  },
  {
    name: "Цзинань",
    url: "/cities/jinan.jpg",
    description: 'Столица провинции Шаньдун на востоке Китая, известен как "Город источников" благодаря многочисленным природным артезианским источникам, самым известным из которых является источник Баоту. Богатая культурная история Цзинаня очевидна в его исторических местах, таких как озеро Дамин и Гора Тысячи Будд, которые предлагают спокойные природные настройки и культурные озарения. Город также является воротами к знаменитой горе Тайшань, одной из пяти священных гор Китая, привлекающей посетителей своими захватывающими пейзажами и историческим значением.  ',
    attractions: [
      "Источник Баоту",
      "Озеро Дамин",
      "Гора Тысячи Будд",
      "Источник Черного тигра",
      "Храм Линъянь",
      ],
  },
  {
    name: "Чэнду",
    url: "/cities/chengdu.jpg",
    description: "Чэнду, столица провинции Сычуань на юго-западе Китая, известен своим неторопливым образом жизни и кухней с сычуаньским перцем, символом которой является знаменитый сычуаньский хотпот. Город представляет собой гармоничное сочетание традиционной культуры и современной городской застройки с оживленными рынками, чайными и яркой ночной жизнью. Чэнду также является воротами в величественные заповедники для гигантских панд, привлекающие поклонников этих милых животных со всего мира.  ",
    attractions: [
      "Центр изучения и разведения гигантской панды",
      "Древняя улица Цзиньли",
      "Храм Ухоу",
      "Парк и Музей китайскому поэту Ду Фу",
      "Монастырь Вэньшу",
      ],
  },
  {
    name: "Чунцин",
    url: "/cities/chongqing.jpg",
    description: 'Чунцин, огромный мегаполис на юго-западе Китая, выделяется своим драматическим ландшафтом, расположенным на крутых холмах у слияния рек Янцзы и Цзялин. Известный как "Город в горах", Чунцин славится своими туманами, придавая ему таинственный ореол. Город сочетает в себе современную городскую застройку с богатым культурным наследием, что видно в его традиционной сычуаньской кухне, особенно остром хотпоте, и исторических местах, таких как древний городок Цыцикоу. Чунцин также служит воротами в Три ущелья, живописный район вдоль реки Янцзы, известный своей природной красотой и монументальной плотиной Три ущелья.  ',
    attractions: [
      "Древний городок Цыцикоу",
      "Пещера Хунья",
      "Три ущелья",
      "Площадь Чаотяньмэнь",
      "Улица Цзефанбэй",
      ],
  },
  {
    name: "Шанхай",
    url: "/cities/shanghai.jpg",
    description: "Глобальный финансовый центр, является мегаполисом, который сочетает восточные и западные культуры. Расположенный у устья реки Янцзы, он известен своей береговой линией воплощенной в футуристической Башне Восточная Жемчужина и набережной Вайтань, демонстрирующей здания колониальной эпохи. Быстрое развитие города и богатая история сосуществуют, предлагая динамичное сочетание современности, традиций и инноваций, делая Шанхай главным направлением для посетителей со всего мира. ",
    attractions: [
      "Башня Восточная Жемчужина",
      "Набережная Вайтань",
      "Сад Юйюань",
      "Небоскреб Шанхайская башня",
      "Нанкинская улица",
      ],
  },
  {
    name: "Тяньцзинь",
    url: "/cities/tianjin.jpg",
    description: "Тяньцзинь, крупный портовый город на севере Китая, сочетает в себе историческую европейскую архитектуру с традиционными китайскими элементами, демонстрируя свое прошлое как договорный порт. Городской пейзаж усеян колониальными зданиями, современными небоскребами и культурными достопримечательностями, такими как Улица древней культуры и Тяньцзиньский глаз, огромное колесо обозрения, построенное над рекой.  ",
    attractions: [
      "Тяньцзиньский глаз",
      "Улица древней культуры",
      "Итальянский концессионный квартал",
      "Улица кухни Наньши",
      "Музей Фарфора",
      ],
  },
  {
    name: "Шэньчжэнь",
    url: "/cities/shenzhen.jpg",
    description: "Шэньчжэнь, расположенный на юго-востоке Китая, -современный мегаполис, который соединяет Гонконг с материковой частью Китая. Город известен своим стремительным ростом из небольшой рыбацкой деревни в оживленный город всего за несколько десятилетий и является глобальным технологическим центром и штаб-квартирой многочисленных высокотехнологичных компаний.",
    attractions: [
      "Тематический парк «Окно в мир»",
      "Тематический парк «Фольклорная деревня Великолепный Китай»",
      "OCT Loft инновационный парк",
      "Ботанический сад города Шэньчжэнь",
      "Международный финансовый центр Пинань",
      ],
  },
  {
    name: "Санья",
    url: "/cities/sanya.jpg",
    description: 'Санья, расположенная на острове Хайнань, является популярным тропическим курортным городом, известным своими первозданными пляжами, кристально чистыми водами и пышной горной местностью. Она служит любимым местом отдыха как для местных, так и для международных туристов, ищущих релаксацию и приключения. Побережье Саньи усеяно роскошными отелями и курортами, что делает её центром досуга и водных видов спорта. В городе также есть культурные объекты, такие как храм Наньшань, демонстрирующий богатое буддийское наследие Китая. Благодаря круглогодичному теплому климату Санью часто называют "Гавайями Китая", предлагая идеальное сочетание естественной красоты и современных удобств. ',
    attractions: [
      "Бухта Ялунвань",
      "Тропический лес Янода",
      "Центр буддизма Наньшань",
      "Долина Люхуйтоу",
      "Пляж Дадунхай",
      ],
  },
  
];
export default cities;
